import { graphql } from "@/gql/__generated__";

export const AddReactivationRequestMutation = graphql(`
  mutation AddReactivationRequest($input: AddReactivationRequestInput!) {
    addReactivationRequest(input: $input) {
      loginRestriction {
        status
        reason
      }
    }
  }
`);
